import React from "react";
import { Row, Button, Form } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { bindActionCreators } from "redux";
import LoadingModal from "../CustomUIComponents/LoadingModal/LoadingModal";
import UserNotification from "../CustomUIComponents/UserNotification/UserNotification";
import {
  generateAuditAction,
  getYearDropdownListAction,
} from "../LoanApplicationList/LoanApplicationListAction";
import { Strings } from "../Translations/i18n";
import { API_RESPONSE_STATUS_CODES } from "../Utils/Constants";

class ViewArchievedData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      auditType: "ADMIN_AUDIT",
      selectedYear: "",
      dropdownData: [],
      error: "",
      success: "",
      showToast: false,
    };
  }

  componentDidMount() {
    this.props.auditScreen !== "USER_MANAGEMENT" &&
      this.getDropdownData(this.props.auditType);
  }

  onChangeYear = (event) => {
    this.setState({
      selectedYear: event.target.value,
    });
  };

  getDropdownData = (auditType) => {
    this.setState({ showLoadingModal: true });
    let dropdownData = [{ id: "", year: Strings("selectYear") }];
    getYearDropdownListAction(auditType, (responseData) => {
      if (responseData.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        dropdownData.push(...responseData.data.data);
        this.setState({ dropdownData, showLoadingModal: false });
      } else {
        this.setState({ dropdownData: [], showLoadingModal: false });
      }
    });
  };

  showNotification = () => {
    if (this.state.showToast) {
      return (
        <UserNotification
          userNotificationObj={{
            message: this.state.message,
            level: this.state.level,
            title: this.state.level === "success" ? "Success !" : "Error !",
          }}
        />
      );
    }
  };

  generateAudit = () => {
    this.setState({
      showLoadingModal: true,
      showToast: false,
      message: "",
      level: "",
    });
    if (!this.state.selectedYear) {
      this.setState({
        errorMessage: Strings("pleaseSelectYear"),
      },
        () => {
          setTimeout(() => {
            this.props.cancelClick();
          }, 5000);
        })

    }
    else {
      generateAuditAction(this.state.selectedYear, (responseData) => {
        if (responseData.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
          this.setState(
            {
              showToast: true,
              message: Strings("archievedDataSuccess"),
              level: "success",
            },
            () => {
              setTimeout(() => {
                this.props.cancelClick();
              }, 5000);
            }
          );
        } else {
          this.setState(
            {
              showToast: true,
              message: Strings(responseData.msg),
              level: "error",
            },
            () => {
              setTimeout(() => {
                this.props.cancelClick();
              }, 5000);
            }
          );
        }
      });
    }
  };

  render() {
    return (
      <>
        <LoadingModal showLoadingModal={this.state.showLoadingModal} />
        {this.showNotification()}
        {((this.props.auditScreen !== "USER_MANAGEMENT" &&
          this.state.auditType !== "") ||
          this.props.auditScreen === undefined) && (
          <Row className="mt-2">
            <div className="errors">{this.state.errorMessage}</div>
            <Form.Select
              type="text"
              componentClass="select"
              onChange={this.onChangeYear}
              value={this.state.selectedYear}
              name={"selectedYear"}
            >
              {this.state.dropdownData.map((item) => {
                return (
                  <option key={item.id} value={item.id}>
                    {item.year}
                  </option>
                );
              })}
            </Form.Select>
          </Row>
        )}
        <div className="my-3 d-flex justify-content-center">
          <Button
            variant=""
            className={"buttonBackground button1  mx-1"}
            onClick={this.generateAudit}
            size="sm"
          >
            {Strings("generateAudit")}
          </Button>

          <Button
            variant=""
            className={"buttonBackground button1 mx-1"}
            size="sm"
            onClick={this.props.cancelClick}
          >
            {Strings("cancel")}
          </Button>
        </div>
      </>
    );
  }
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getYearDropdownListAction: getYearDropdownListAction,
      generateAuditAction: generateAuditAction,
    },
    dispatch
  );
}

export default withRouter(
  connect(null, matchDispatchToProps)(ViewArchievedData)
);
